import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogAccountType } from "../../store/catalog/actions";
export var GetCatalogAccountType = function (trigger, enable, page, limit, clientId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalogAccountType: (_a = state.Catalog.responseGetCatalogAccountType) === null || _a === void 0 ? void 0 : _a.data,
            loadingGetCatalogAccountType: state.Catalog.loadingGetCatalogAccountType,
            errorGetCatalogAccountType: state.Catalog.errorGetCatalogAccountType,
        });
    }), responseGetCatalogAccountType = _a.responseGetCatalogAccountType, loadingGetCatalogAccountType = _a.loadingGetCatalogAccountType, errorGetCatalogAccountType = _a.errorGetCatalogAccountType;
    useEffect(function () {
        if (trigger) {
            dispatch(getCatalogAccountType({
                enable: enable,
                page: page,
                limit: limit,
                type: "CATALOG_ACCOUNT_TYPE",
                clientId: clientId,
            }));
        }
    }, [trigger, enable, page, limit, clientId]);
    return {
        responseGetCatalogAccountType: responseGetCatalogAccountType,
        loadingGetCatalogAccountType: loadingGetCatalogAccountType,
        errorGetCatalogAccountType: errorGetCatalogAccountType,
    };
};
